import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import typescript from '../assets/typescript.png';
import csharp from '../assets/csharp.png';
import email from '../assets/email.png';
import mobile from '../assets/mobile.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';


// eslint-disable-next-line import/no-anonymous-default-export
export default {
  javascript,
  node,
  react,
  typescript,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  csharp,
  email,
  mobile
};